import { EventStatusEnum } from "../Enums/EventStatusEnum";

export const EventStatusTabMapping: { [index: number]: EventStatusEnum } = {
  // tabIndex: Status
  0: EventStatusEnum.Active,
  1: EventStatusEnum.Published,
  2: EventStatusEnum.Created,
  3: EventStatusEnum.Finished
};
